/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_ReturnsInputs */

const tr_landing_cockpit_stat_returns = /** @type {(inputs: Landing_Cockpit_Stat_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iade oranı`)
};

const en_landing_cockpit_stat_returns = /** @type {(inputs: Landing_Cockpit_Stat_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`return rate`)
};

const de_landing_cockpit_stat_returns = /** @type {(inputs: Landing_Cockpit_Stat_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retourenquote`)
};

const ru_landing_cockpit_stat_returns = /** @type {(inputs: Landing_Cockpit_Stat_ReturnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`доля возвратов`)
};

/**
* | output |
* | --- |
* | "return rate" |
*
* @param {Landing_Cockpit_Stat_ReturnsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_returns = /** @type {((inputs?: Landing_Cockpit_Stat_ReturnsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_ReturnsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_returns(inputs)
	if (locale === "de") return de_landing_cockpit_stat_returns(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_returns(inputs)
	return tr_landing_cockpit_stat_returns(inputs)
});